import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=bb0b6802&scoped=true"
import script from "./Overview.vue?vue&type=script&setup=true&lang=js"
export * from "./Overview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Overview.vue?vue&type=style&index=0&id=bb0b6802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0b6802",
  null
  
)

export default component.exports